module.exports = __webpack_public_path__ + "img/shutterstock_447921760-800x292.a7ca1014.jpg";